module.exports = __webpack_public_path__ + "img/bca_logo_1.f6350fb2.svg";